import FormInputTypes from '../components/atoms/formEnums/formInputTypes';


export default {
  title: 'General values',
  attributeName: 'generalValues',
  fields: [
    {
      attributeName: 'isUserNameRequired',
      helpText: 'If it is checked the user must write a username.',
      type: FormInputTypes.CHECKBOX,
      label: 'Username required',
      placeholder: '',
      default: false,
    },
    {
      attributeName: 'userNamePrompt',
      helpText: 'Text to help the user when the username is prompted.',
      type: FormInputTypes.TEXT_INPUT.TEXT,
      label: 'Username prompt text',
      placeholder: 'Write a username prompt text...',
      default: '',
    },
    {
      attributeName: 'categoriesIsEnable',
      helpText: 'Enable or disable the categories panel.',
      type: FormInputTypes.CHECKBOX,
      label: 'Categories panel',
      placeholder: 'Video name...',
      default: true,
    },
    {
      attributeName: 'mainPanelColumns',
      label: 'Main Panel columns',
      helpText: 'The number of columns the main panel must present.',
      default: [2],
      type: FormInputTypes.SELECT,
      options: [
        { name: 1, value: 1 },
        { name: 2, value: 2 },
        { name: 3, value: 3 },
        { name: 4, value: 4 },
      ],
    },
    {
      attributeName: 'refreshIsEnable',
      helpText: 'Enable or disable the refresh button.',
      type: FormInputTypes.CHECKBOX,
      label: 'Refresh button',
      default: true,
    },
    {
      attributeName: 'homeGraphicsManifest',
      helpText: 'This is a URL to the dynamic graphics manifest that’s going to be applied to the home scene if there’s no skin home graphics manifest defined in the skin selector config section.',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Home Graphics Manifest',
      fileType: ['.json'],
    },
    {
      attributeName: 'videoPlayerGraphicsManifest',
      helpText: 'This is a URL to the dynamic graphics manifest that’s going to be applied to the video player scene only when there hasn’t been specified a graphics manifest for the specific video that’s being played or for the current skin.',
      type: FormInputTypes.DOWNLOADABLE,
      label: 'Video Player Graphics Manifest',
      fileType: ['.json'],
    },
    {
      attributeName: 'logManagerConfig',
      helpText: 'Log Manager Config: tells the app which configuration should be used for the logs.',
      type: FormInputTypes.SELECT,
      options: [
        { name: 'release', value: 'release' },
        { name: 'debug', value: 'debug' },
      ],
      label: 'Log config',
      default: ['release'],
    },
  ],
};
